
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { BillServiceWiseReport } from '../../../interfaces/report/bill-service-wise-report';

@Injectable()
export class BillServiceWiseReportApi {

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
   
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  getById(url: string, options?: any): Observable<BillServiceWiseReport> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: BillServiceWiseReport):Observable<BillServiceWiseReport>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }

  update(url:string, data: BillServiceWiseReport):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, header);
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }

  searchList(url: string, data:any):Observable<any[]>{
   
    let header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"}); 
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
}
